import React from 'react';

const SuccessIcon = ({ width = 100, height = 100 }) => (
    <svg width={width} height={height} className="icon icon-success" viewBox="0 0 100 100">
        <path d="M50 0c27.614 0 50 22.386 50 50s-22.386 50-50 50S0 77.614 0 50 22.386 0 50 0zm0 5C25.147 5 5 25.147 5 50s20.147 45 45 45 45-20.147 45-45S74.853 5 50 5zm28.716 24.182c.96.907 1.044 2.394.22 3.4l-.118.134L41.17 72.583 23.236 54.718c-.979-.975-.982-2.557-.007-3.536.932-.935 2.42-.979 3.404-.128l.131.122 14.296 14.24 34.122-36.132c.948-1.004 2.53-1.05 3.534-.102z" />
    </svg>
);

export default SuccessIcon;
